import { memo } from 'react';

const Preloader = memo(() => {
  return <div id="preloader"></div>;
});

Preloader.displayName = 'Preloader';

export default Preloader;